import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentLines } from "@fortawesome/pro-regular-svg-icons/faCommentLines";

export const defaultTranslations = {
    pluginName: "Testimonials",
    pluginDescription: "Add customer testimonials",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faCommentLines} size="3x" />,
};
